import { render, staticRenderFns } from "./ScoutingReportDetail.vue?vue&type=template&id=509ffc21&"
import script from "./ScoutingReportDetail.vue?vue&type=script&lang=js&"
export * from "./ScoutingReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports